export default __webpack_public_path__ + "static/ryan@2x-53c8c80f330a61058103cd517cdb80da.jpg";